import React from 'react';
import VideoGadget from './VideoGadget';
import Loading from '../Loading';
import usePopup from '../../hooks/usePopup';
import useVideoSrc from './useVideoSrc';

const VideoGadgetContainer = ({ storagePath }: { storagePath: string }) => {
  const {
    isOpen: isEditFormOpen,
    open: openEditForm,
    close: closeEditForm,
  } = usePopup();
  const {
    videoSrc: downloadUrl,
    setVideoSrc: setDownloadUrl,
    isLoading,
  } = useVideoSrc(storagePath);

  if (downloadUrl && !isLoading) {
    return (
      <VideoGadget
        src={downloadUrl}
        setSrc={setDownloadUrl}
        storagePath={storagePath}
        isEditFormOpen={isEditFormOpen}
        openEditForm={openEditForm}
        closeEditForm={closeEditForm}
      />
    );
  } else {
    return <Loading />;
  }
};

export default VideoGadgetContainer;
